module.exports = __webpack_public_path__ + "static/media/exchangeNewKTM.3b8aad9e.svg";